//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import ListLedger from '@/views/ledger/ListLedger'
import DetailsLedger from '@/views/ledger/DetailsLedger'

//
export default {
    path: 'ledger',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'ledger-list',
            component: ListLedger,
        },
        {
            path: ':id',
            name: 'ledger-update',
            component: DetailsLedger,
        },
    ],
    meta: {
        group: 'Contabilidad',
        title: 'Libro mayor',
    },
}
